import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import UserManualService from './userManual.service'

const useUserManual = () => {
  const service = new UserManualService()
  const baseCrud = useCrud(API_RESOURCE.USER_MANUAL, service)

  const useFetchUserManualByType = (type) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.details(), type],
      queryFn: () => service.fetchUserManualByType(type),
      placeholderData: keepPreviousData,
    })
  }

  return {
    useFetchUserManualByType,
    useUpdateUserManual: baseCrud.useUpdate,
  }
}

export default useUserManual
